export default __webpack_public_path__ + "static/media/opclose-12.c9bfe1a0.svg";